import axiosInstance from "@/api/axios-instance";

export async function updateCouplesPackProfessional({
  professional_id,
  couples_pack_usage_identifier
}: {
  professional_id: string
  couples_pack_usage_identifier: string;
}) {
  const response = await axiosInstance.put(`/couples-packs/update-professional`, {
    professional_id,
    couples_pack_usage_identifier,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update professional");
  }

  return response.data;
}